import { render, staticRenderFns } from "./CookiesBanner.vue?vue&type=template&id=397d42c1&scoped=true"
import script from "./CookiesBanner.vue?vue&type=script&lang=js"
export * from "./CookiesBanner.vue?vue&type=script&lang=js"
import style0 from "./CookiesBanner.vue?vue&type=style&index=0&id=397d42c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d42c1",
  null
  
)

export default component.exports